import React from 'react';

 
const Table  = (props) => {
    
   
    return (
        <div>
            <table id='table'>
            <thead>
            <tr>
            <th><h3>Authors Cited in document but not References List.</h3></th>
            <th><h3>Authors Listed but not found in document.</h3></th>
            </tr>
            </thead>
            <tbody>
            <tr>
            <td>{props.incorrect}</td>
            <td>{props.incorrectBib}</td>
            </tr>
            </tbody>
            </table>
        </div>
       
    )
   
    };
    
export default Table;